/**
 * Status colours of rentable objects (parking spots, storage units, units) on
 * drawing markers: green when free to let, grey otherwise. Same values as iOS.
 */
export const VACANT_COLOR = '#36c356';
export const RENTED_COLOR = '#8f8f8f';
